import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './file-download.module.css';

type Props = {
  readonly fileName:
    | 'プレスリリース'
    | '参考資料'
    | 'プレスリリース（会員限定）'
    | '参考資料（会員限定）'
    // v3
    | 'プレスリリース添付資料'
    | 'プレスリリース添付資料（会員限定）';
  readonly extension: string;
  readonly href: string;
};

export function PressReleaseInformationFileDownload({
  fileName,
  extension,
  href,
}: Props) {
  return (
    <a
      download
      href={href}
      className={clsx(
        styles.button,
        isContainerQueryAvailable()
          ? styles.buttonPressReleaseRoot
          : styles.buttonScreen,
      )}
    >
      <DownloadIcon />
      <span>
        {fileName}.{extension}
      </span>
    </a>
  );
}

function DownloadIcon() {
  return (
    <svg
      aria-hidden='true'
      width='20'
      height='18'
      viewBox='0 0 20 18'
      fill='none'
      className={styles.icon}
    >
      <g clipPath='url(#clip0_3895_35412)'>
        <path
          d='M0 13V16C0 17.093 0.907 18 2 18H18C19.093 18 20 17.093 20 16V13H18V16H2V13H0ZM9 0V10.586L4.707 6.293L3.293 7.707L10 14.414L16.707 7.707L15.293 6.293L11 10.586V0H9Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_3895_35412'>
          <rect width='20' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
